import { Box } from "@mui/material";
import ExperienceCard from "components/elements/experience_card";
import {
  BoxMotion,
  TypographyMotion,
} from "components/elements/material_motion";
import { firebaseDatabase } from "config/firebase";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { NAVIGATION_SET_MENU } from "utils/redux/action";

export default function ExperiencePage() {
  const dispatcher = useDispatch();

  const [experiences, setExperiences] = useState([]);

  useEffect(() => {
    dispatcher({ type: NAVIGATION_SET_MENU, index: 2 });
  }, [dispatcher]);

  useEffect(() => {
    const listenerExperiences = onSnapshot(
      query(collection(firebaseDatabase, "experiences"), orderBy("start_at")),
      (_) => setExperiences(_.docs.map((_) => ({ id: _.id, ..._.data() })))
    );

    return () => listenerExperiences();
  }, []);

  return (
    <Box sx={{ position: "relative", padding: { xs: 0, sm: "0 10px" } }}>
      <TypographyMotion
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ type: "spring", delay: 0.0, duration: 1 }}
        variant="h2"
        sx={{
          fontFamily: "Poppins",
          fontWeight: 700,
          fontSize: { xs: 20, md: 24 },
          color: "black",
          margin: 0,
        }}
      >
        Pengalaman Bekerja
      </TypographyMotion>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          padding: "0 8px",
          marginTop: 3,
          gap: 2.5,
        }}
      >
        {experiences
          .filter((_) => _.enabled)
          .map((_, __) => (
            <BoxMotion
              key={__}
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ type: "spring", delay: 0.1 * __, duration: 1 }}
            >
              <ExperienceCard data={_} />
            </BoxMotion>
          ))}
      </Box>
    </Box>
  );
}
